import ParameterErrors from '../errors/ParameterErrors';
import ParseError from '../errors/ParseError';
import PixelMappings from '../pixel_mapping/PixelMappings';
import SiteJsonUnitBirdsEyeViewOutside360MarkerPosition from './SiteJsonUnitBirdsEyeViewOutside360MarkerPosition';
const { throwNotProvided, throwNotOfType} = ParameterErrors;
export default class SiteJsonBirdsEyeViewsBirdsEyeView{
	constructor(props){
		const {imageRelativePath, imageAspectRatio, angle, nearestOutside360PixelMappings, outside360MarkerPositions}=props;
		if(!imageRelativePath)throwNotProvided('imageRelativePath');
		this._imageRelativePath = imageRelativePath;
		if(!imageAspectRatio)throwNotProvided('imageAspectRatio');
		this._imageAspectRatio = imageAspectRatio;
		/*if(angle===null||angle===undefined)
			throwNotProvided('index');
		if(typeof(index)!=='number')
			throwNotOfType('index', 'number');
		*/
		this._angle = angle
		
		//if(nearestOutside360PixelMappings===undefined||nearestOutside360PixelMappings===null)
			//throwNotProvided('nearestOutside360PixelMappings');
		this._nearestOutside360PixelMappings= nearestOutside360PixelMappings;
		
		//if(outside360MarkerPositions===undefined||outside360MarkerPositions===null)
			//throwNotProvided('outside360MarkerPositions');
		this._outside360MarkerPositions= outside360MarkerPositions;
		this._mapOutside360UniqueIdToMarkerPosition={};
		this._outside360MarkerPositions?.forEach(outside360MakerPosition=>
			this._mapOutside360UniqueIdToMarkerPosition[outside360MakerPosition.outside360UniqueId]= outside360MakerPosition.markerPosition
		);
		this.getMarkerPositionForOutside360= this.getMarkerPositionForOutside360.bind(this);
	}
	get angle(){
		return this._angle;
	}
	get imageRelativePath(){
		return this._imageRelativePath;
	}
	get imageAspectRatio(){
		return this._imageAspectRatio;
	}
	get nearestOutside360PixelMappings(){
		return this._nearestOutside360PixelMappings;
	}
	getMarkerPositionForOutside360(outside360UniqueId){
		return this._mapOutside360UniqueIdToMarkerPosition[outside360UniqueId];
	}
	static fromJSON(jObject, configuration){
		return new SiteJsonBirdsEyeViewsBirdsEyeView({
			angle:jObject.angle,
			imageRelativePath:jObject.imageRelativePath,
			imageAspectRatio:jObject.imageAspectRatio,
			nearestOutside360PixelMappings:jObject.nearestOutside360PixelMappings?PixelMappings.fromJSON(jObject.nearestOutside360PixelMappings, configuration):null,
			outside360MarkerPositions:jObject.outside360MarkerPositions?jObject.outside360MarkerPositions.map(outside360MarkerPosition=>SiteJsonUnitBirdsEyeViewOutside360MarkerPosition.fromJSON(outside360MarkerPosition)):null
		});
	}
}